import { render, staticRenderFns } from "./cronDashboard.vue?vue&type=template&id=4570d248"
import script from "./cronDashboard.vue?vue&type=script&lang=js"
export * from "./cronDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports